import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useLayoutContext } from '../../Contexts/LayoutContext';

interface HeaderLogoProps {
    className?: string;
    classNameImage?: string;
}

const HeaderLogo = ({ className, classNameImage } : HeaderLogoProps) => {

    const location = useLocation();
    const { company } = useLayoutContext();
    const { getLinkToHome } = useStoreHook();

    return (

        <Link to={getLinkToHome()} className={`
            flex items-center justify-start h-full max-h-20 min-w-12 max-w-24 md:max-w-40 py-2
            ${location.pathname === getLinkToHome() && 'pointer-events-none'}
            ${className}
        `}>
            {company &&
                <img src={company.vector_image ?? company.image} alt={company.name} className={`
                    h-full object-contain
                    transition-[width] ease-in-out duration-200
                    ${classNameImage}
                `} />
            }
        </Link>
    );
};

export default HeaderLogo;
